import React from 'react'
import {Field,ErrorMessage} from 'formik';
import {FormControl,FormControlLabel,InputLabel,OutlinedInput,TextField,Typography,useTheme} from '@mui/material';
import {tokens} from '../../../../theme';

const File = (props) => {
  const{label,name,type, ...rest}=props;
  const theme=useTheme();
  const colora=tokens(theme.palette.mode)


return (
<>
<Field name={name}  >
 
{
({field,form})=>{
  const {setFieldValue}=form;
  const{value}=field;
return(
<FormControl size='small'    >
        
            <Field
           
           
           
             name={name}
             id={name}
             {...rest}
             type={type}
             value={value}
          

             onChange={(newValue) => {
              
  
            setFieldValue(value,newValue)
  
      
            
          }
        }
             
                       >
 
            </Field>


            <Typography color='red' mt='-9px' ml='9px' fontSize='0.6rem'>
            <ErrorMessage name={name}  ></ErrorMessage>
            </Typography>


</FormControl>)
}
}
</Field>


  </>
  








)

  

 
 


}

export default File